jQuery(document).ready(function($) {
  if (!$('.b-image-video-text').length) {
    return;
  }

  $(window).on('scroll', function() {
    if($(this).scrollTop() >= $('.b-image-video-text').position().top - 400) {
      $('.b-image-video-text__video video').css('opacity', 1).get(0).play();
    }
  });
});



// WEBPACK FOOTER //
// ./scripts/blocks/image-video-text.js